export default "__VITE_PUBLIC_ASSET__5847cd8b__"